import { render, staticRenderFns } from "./LaborProtectionRatingItem.vue?vue&type=template&id=8d3d30aa&"
import script from "./LaborProtectionRatingItem.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionRatingItem.vue?vue&type=script&lang=ts&"
import style0 from "./LaborProtectionRatingItem.vue?vue&type=style&index=0&id=8d3d30aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports